import styled from 'styled-components';
import { ReactComponent as Tag } from 'Images/tag.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 5px 13px 0;
  align-items: center;
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  font-size: 21.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.sideModaTitle};
`;
Title.displayName = 'Title';

export const WrapperButtons = styled.div`
  display: flex;
  margin-left: auto;
  & > :first-child {
    margin-right: auto;
  }
  & > :last-child {
    margin-left: 8px;
  }
`;
WrapperButtons.displayName = 'WrapperButtons';

export const TagIcon = styled(Tag)`
  margin-right: 20px;
  cursor: default;
  width: 24px;
  & g {
    & path{
      fill: ${({ theme }) => theme.text.sideModaTitle};
    }  
  }
`;
TagIcon.displayName = 'TagIcon';
